import { get } from 'lodash';
import React, { useState } from 'react';
import { classnames } from '../../utils/text';
import Button from '../../components/Button';
import consultingPopup from '../../utils/consulting';
import { login } from '../../apis/auth';
import systemAlert from '../../utils/systemAlert';
import { deleteUser } from '../../apis/users';

const DeleteUser = () => {
  const [focusInput, setFocusInput] = useState({
    id: false,
    password: false,
  });
  const [loginInfo, setLoginInfo] = useState({
    id: "",
    password: "",
  });

  const setUserInfo = (e) => {
    const { name, value } = e.target;
    setLoginInfo({ ...loginInfo, [name]: value });
  };

  const handleLogin = () => {
    login({
      id: loginInfo.id,
      password: loginInfo.password,
    }).then(res => {
      systemAlert(`정말 "${res.name}"님의 계정 "${res.id}"를(을) 삭제하시겠습니까?`,
        {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '탈퇴',
              color: 'red',
              onClick: () => {
                deleteUser(res.idx).then(() => {
                  systemAlert("회원 탈퇴가 완료되었습니다.", {
                    buttons: [
                      {
                        label: "확인",
                        onClick: () => window.location.href = '/logout'
                      }
                    ]
                  });

                });
              }
            }
          ]
        });
    });
  };


  const handleOnFocus = (e) => {
    const { name } = e.target;
    setFocusInput({
      ...focusInput,
      [name]: true,
    });
  };

  const handleOnBlur = (e) => {
    const { name } = e.target;
    setFocusInput({
      ...focusInput,
      [name]: false,
    });
  };



  return (
    <>
      <div className="Login auth-wrap delete-user">
        <div className="login-form-wrap">
          <div className="login-form">
            <h1>회원탈퇴</h1>
            <p>탈퇴하실 아이디 및 비밀번호를 입력하세요.</p>
            <p>탈퇴후의 계정은 복구가 불가합니다.</p>
            <div
              className={classnames("focus-password", {
                active: get(focusInput, "password"),
              })}
            />
            <div className="form-wrap">
              <div
                className={classnames("input-wrap", {
                  active: get(focusInput, "id"),
                })}
              >
                <div className="form-floating">
                  <input
                    type="text"
                    id="floatingnameInput"
                    className="form-control"
                    placeholder="&nbsp;"
                    name="id"
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        document.getElementById("password-input").focus();
                      }
                    }}
                    defaultValue={get(loginInfo, "id")}
                    onChange={setUserInfo}
                    onFocus={handleOnFocus}
                    onBlur={handleOnBlur}
                  />
                  <label htmlFor="floatingnameInput">
                    아이디를 입력해주세요.
                  </label>
                </div>
              </div>
              <div
                className={classnames("divider", {
                  none: get(focusInput, "id") || get(focusInput, "password"),
                })}
              />
              <div />
              <div
                className={classnames("input-wrap", {
                  active: get(focusInput, "password"),
                })}
              >
                <div className="form-floating">
                  <input
                    className="form-control"
                    placeholder="&nbsp;"
                    id="password-input"
                    name="password"
                    type="password"
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        handleLogin();
                      }
                    }}
                    onChange={setUserInfo}
                    onFocus={handleOnFocus}
                    onBlur={handleOnBlur}
                  />
                  <label htmlFor="password-input">비밀번호를 입력해주세요</label>
                </div>
              </div>
            </div>

            <Button
              size="lg"
              className="w-full mt-15"
              color="red"
              onClick={handleLogin}>
              회원탈퇴
            </Button>

            <div className="horizontal-divider" />

            <div className="inquire-wrap">
              <label
                className="cursor-pointer"
                onClick={() => {
                  consultingPopup(true);
                }}
              >WeCake에 문의</label>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteUser;